import React, { useCallback } from 'react';
import {
  createStyles,
  makeStyles,
  Theme,
} from '@material-ui/core';
import clsx from 'clsx';

import { Filter } from '../../types/main';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    fontSize: '14px',
    fontFamily: 'Montserrat',
    padding: 8,
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    color: 'inherit',
    '&:hover': {
      color: palette.filterChip.hover,
    },
    outline: 'unset',
  },
  active: {
    borderBottom: `2px solid ${palette.filterChip.active}`,
    color: palette.filterChip.active,
  },
  tabStyles: {
    fontSize: 16,
  },
  disabled: {
    '&:hover': {
      color: 'inherit',
      cursor: 'auto',
    },
  },
}), { name: 'FilterChip' });

type Props = {
  objKey: string;
  label: string;
  isActive: boolean;
  value: string | number | string[];
  onChange: (filter: Filter, state: boolean, multi: boolean) => void;
  filters?: Filter[];
  tabStyles?: boolean;
  disabled?: boolean;
};

const FilterChip = ({
  objKey: key,
  label,
  value,
  isActive,
  onChange,
  filters,
  tabStyles = false,
  disabled = false,
}: Props) => {
  const classes = useStyles();

  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      onChange(
        {
          key,
          value,
          filters,
        },
        !isActive,
        e.shiftKey,
      );
    },
    [onChange, key, value, isActive, filters],
  );

  return (
    <button
      tabIndex={-1}
      type="button"
      onClick={handleClick}
      className={clsx(classes.root, {
        [classes.active]: isActive,
        [classes.tabStyles]: tabStyles,
        [classes.disabled]: disabled,
      })}
      disabled={disabled}
    >
      <div>{label}</div>
    </button>
  );
};

export default FilterChip;
